import '@ddt/ui/style.css';
import '@fontsource/lilita-one/400.css';
import '@fontsource/baloo-2/600.css';
import '@fontsource/baloo-2/700.css';
import '@fontsource/baloo-2/800.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/700.css';
import './assets/app.css';
import './ui/gold-panel.css';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { createNavigator, entryFromLocation } from './navigation';
import { getServices } from './services';
import { useSession } from './stores/session';

const pinia = createPinia();
const nav = createNavigator();
const app = createApp(App);
app.use(pinia);
app.use(nav);

// O Vue DevTools vem do `vite-plugin-vue-devtools` (só no `vite dev`). `performance` liga a aba de desempenho dos componentes.
app.config.performance = import.meta.env.DEV;

// Sessão expirada (refresh recusado): limpa o estado e volta para a entrada.
getServices().sessionExpired.handler = () => {
  useSession().clear();
  nav.reset({ name: 'login', query: { redirect: nav.current.value.name } });
};

// Restaura a sessão ANTES de abrir a primeira tela: as regras de entrada precisam saber quem é o usuário.
void useSession()
  .restore()
  .finally(() => {
    // O endereço só é lido agora, na abertura (link do e-mail de nova senha). Depois a URL volta para `/` e não muda mais.
    const entry = entryFromLocation(window.location.pathname, window.location.search);
    window.history.replaceState(null, '', '/');
    nav.reset(entry ?? 'home');
    app.mount('#app');
  });
